module.exports = __webpack_public_path__ + "static/media/Nunito-Regular.d2e691bc.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/Nunito/Nunito-Regular.ttf
// module id = 300
// module chunks = 0